
import Vue from "vue";
import API from "@/api/API";
import store from "@/store";

export default Vue.extend({
  name: "Create",

  data: () => ({
    model: {
      name: "" as string,
    } as any,
    item: {} as any,
    fullLoaded: false as boolean,
    errorMessages: {} as any,
    rules: {
      required: [(v: string): boolean | string => !!v || "Câmp obligatoriu!"],
    },
  }),

  computed: {
    computedRules(): object {
      return {
        min: this.minLength,
      };
    },
  },

  async beforeRouteEnter(to, from, next) {
    try {
      const item = await API.roles().getForEdit(Number(to.params.id));

      next((vm) => {
        vm.item = item;
        vm.model.name = item.dataObject.name;
        vm.$nextTick(() => {
          vm.fullLoaded = true;
        });
      });
    } catch (e) {
      await store.dispatch("alert/showError", e.message);
    }
  },

  methods: {
    minLength(number: number): Function {
      return (v: string): boolean | string =>
        v?.length >= number || `Valoarea minima: ${number}`;
    },
    async submit(): Promise<void> {
      try {
        if ((this.$refs.form as any).validate()) {
          await this.$API
            .roles()
            .edit(this.$route.params.id as any, this.model);
          await this.$router.push("/roles");
          await this.$store.dispatch(
            "alert/showSuccess",
            "Rolul a fost actualizat cu succes."
          );
        }
      } catch (e) {
        if (e.hasOwnProperty("errors")) {
          this.errorMessages = e.errors;
          setTimeout(() => {
            this.errorMessages = {};
          }, 2000);
        }
        await this.$store.dispatch("alert/showError", e.message);
      }
    },
  },
});
